export const True = 'true'

export const False = 'false'
